/**
 * Solanaland
 *
 * Author: Venus Lumanglas
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import React from "react";
import { Table } from "core/components";
import moment from "moment";

const ProjectMaterialReturn = ({ materialReturn }): JSX.Element => {
  const materialReturnItems = materialReturn.material_return_items;

  const columns = React.useMemo(
    () => [
      {
        id: "id",
        Header: "Id",
        accessor: "id"
      },
      {
        Header: "Inventory ID",
        accessor: "item.code",
        Cell: (props) => {
          return <p className="text-center">{props.value}</p>;
        }
      },
      {
        Header: "Inventory Item",
        accessor: "item.name",
        Cell: (props) => {
          return (
            <p className="text-truncate" title={props.value} data-bs-toggle="tooltip">
              {props.value}
            </p>
          );
        }
      },
      {
        Header: "UOM",
        accessor: "unit_measure_code",
        Cell: (props) => {
          return <p className="text-center">{props.value}</p>;
        }
      },
      {
        Header: "Returned Quantity",
        accessor: "returned_quantity",
        Cell: (props) => {
          return <p className="text-center text-bold">{props.value || "-"}</p>;
        }
      },
      {
        Header: "State",
        accessor: "state",
        Cell: (props) => {
          const state = I18n.t(`activerecord.attributes.material_return_item.states.${props.value}`);

          return (
            <div title={state} data-bs-toggle="tooltip">
              <p className="text-truncate text-center">{state}</p>
            </div>
          );
        }
      },
      {
        Header: "Date Created",
        accessor: "created_at",
        Cell: (props) => {
          return (
            <div title={moment(props.value).format("MM/DD/YYYY")} data-bs-toggle="tooltip">
              <p className="text-center text-truncate">{moment(props.value).format("MM/DD/YYYY")}</p>
            </div>
          );
        }
      },
      {
        Header: "Remarks",
        accessor: "remarks",
        Cell: (props) => {
          return (
            <p className="text-truncate" title={props.value} data-bs-toggle="tooltip">
              {props.value}
            </p>
          );
        }
      }
    ],
    []
  );

  return (
    <React.StrictMode>
      <Table columns={columns} data={materialReturnItems} />
    </React.StrictMode>
  );
};

export default ProjectMaterialReturn;
